import { UserFormPersonalDetails } from '@/app/pages/user-form/user-form-self-details';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/user-form/self-details')({
  validateSearch: z.object({
    travelId: z.string().uuid(),
    email: z.string().optional(),
    phone: z.number().optional(),
  }),
  component: UserFormPersonalDetails,
});
